"use strict";
// DO NOT EDIT. Generated by gitlab.com/accumulatenetwork/accumulate/tools/cmd/gen-types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var MessageType;
(function (MessageType) {
    /** Transaction is a transaction. */
    MessageType[MessageType["Transaction"] = 1] = "Transaction";
    /** Signature is a signature. */
    MessageType[MessageType["Signature"] = 2] = "Signature";
    /** BadSynthetic is deprecated. */
    MessageType[MessageType["BadSynthetic"] = 3] = "BadSynthetic";
    /** BlockAnchor is a block anchor signed by validator. */
    MessageType[MessageType["BlockAnchor"] = 4] = "BlockAnchor";
    /** Sequenced is a message that is part of a sequence. */
    MessageType[MessageType["Sequenced"] = 5] = "Sequenced";
    /** SignatureRequest is a request for additional signatures. */
    MessageType[MessageType["SignatureRequest"] = 6] = "SignatureRequest";
    /** CreditPayment is a payment of credits towards a transaction's fee. */
    MessageType[MessageType["CreditPayment"] = 7] = "CreditPayment";
    /** BlockSummary is a summary of a block. */
    MessageType[MessageType["BlockSummary"] = 8] = "BlockSummary";
    /** Synthetic is a message produced by the protocol, requiring proof. */
    MessageType[MessageType["Synthetic"] = 9] = "Synthetic";
    /** NetworkUpdate is an update to network parameters. */
    MessageType[MessageType["NetworkUpdate"] = 10] = "NetworkUpdate";
    /** MakeMajorBlock triggers a major block. */
    MessageType[MessageType["MakeMajorBlock"] = 11] = "MakeMajorBlock";
    /** DidUpdateExecutorVersion notifies the DN that a BVN updated the executor version. */
    MessageType[MessageType["DidUpdateExecutorVersion"] = 12] = "DidUpdateExecutorVersion";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
/** @ignore */
(function (MessageType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    MessageType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "transaction":
                return MessageType.Transaction;
            case "signature":
                return MessageType.Signature;
            case "badsynthetic":
                return MessageType.BadSynthetic;
            case "blockanchor":
                return MessageType.BlockAnchor;
            case "sequenced":
                return MessageType.Sequenced;
            case "signaturerequest":
                return MessageType.SignatureRequest;
            case "creditpayment":
                return MessageType.CreditPayment;
            case "blocksummary":
                return MessageType.BlockSummary;
            case "synthetic":
                return MessageType.Synthetic;
            case "networkupdate":
                return MessageType.NetworkUpdate;
            case "makemajorblock":
                return MessageType.MakeMajorBlock;
            case "didupdateexecutorversion":
                return MessageType.DidUpdateExecutorVersion;
            default:
                throw new Error(`Unknown MessageType '${name}'`);
        }
    }
    MessageType.byName = byName;
    function getName(v) {
        switch (v) {
            case MessageType.Transaction:
                return "transaction";
            case MessageType.Signature:
                return "signature";
            case MessageType.BadSynthetic:
                return "badSynthetic";
            case MessageType.BlockAnchor:
                return "blockAnchor";
            case MessageType.Sequenced:
                return "sequenced";
            case MessageType.SignatureRequest:
                return "signatureRequest";
            case MessageType.CreditPayment:
                return "creditPayment";
            case MessageType.BlockSummary:
                return "blockSummary";
            case MessageType.Synthetic:
                return "synthetic";
            case MessageType.NetworkUpdate:
                return "networkUpdate";
            case MessageType.MakeMajorBlock:
                return "makeMajorBlock";
            case MessageType.DidUpdateExecutorVersion:
                return "didUpdateExecutorVersion";
            default:
                throw new Error(`Unknown MessageType ${v}`);
        }
    }
    MessageType.getName = getName;
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=enums_gen.js.map